/**
 * English messages of the timeline host (W1-15 timeline-host): accessible names of the timeline regions and
 * the built-in columns. Render code cannot import the i18n runtime, so the host builds MessageRefs from these keys
 * and translates them with the `translate` function the timeline panel injects (`services.i18n.tr`); without one it
 * falls back to this English catalogue.
 */

import { catalogOf, defineMessages } from '../../i18n/define';

export const m = defineMessages('timeline', {
  region: 'Timeline',
  columns: 'Timeline columns',
  gutter: 'Beat ruler',
  gutterHint:
    'Click to move the playhead, drag the playhead to scrub (hold {loop} for no snap), drag elsewhere to select a time range and everything in it, {loop}+drag to set the loop',
  waveform: 'Waveform',
  overview: 'Song overview',
  overviewHint: 'Click or drag to jump to that part of the song, {loop}+drag to set the loop',
  /**
   * Names for {loop}: the loop-drag modifier, which is also the no-snap modifier of a scrub (default keymap /
   * Alt-free variant, other systems / macOS).
   */
  loopKeyAlt: 'Alt',
  loopKeyOption: 'Option',
  loopKeyCtrlShift: 'Ctrl+Shift',
  loopKeyCmdShift: 'Cmd+Shift',
  resizeColumn: 'Resize column: {name}',
  column: 'Column',
});

export default catalogOf(m);
